import { useState } from "react";
import { Grid, Modal, Button, TextField, Select, MenuItem, InputLabel, FormControl } from "@mui/material";
import s from "./ModalFiltros.module.css";
import CloseIcon from "@mui/icons-material/Close";
import { DatePicker } from "@mui/x-date-pickers";
import { useTranslation } from "react-i18next";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import "dayjs/locale/es";
import "dayjs/locale/pt";
import { useSelector } from "react-redux";
import { CIERRE_FILTER_OPTIONS } from "../cierreTipo";

const ModalFiltros = ({
  open,
  setOpen,
  setFilters,
  setSearching,
  setSearch,
  fecha,
  setFecha,
}) => {
  const { t, i18n } = useTranslation();
  const [tipo, setTipo] = useState("");
  const agencieSelected = useSelector(
    (state) => state.myAgencies?.selected_agencie_to_consult,
  );

  const handleChangeDate = (date_picked) => {
    setFecha(date_picked);
    setFilters((prev) => ({
      ...prev,
      fecha: `${date_picked.$D < 10 ? "0" : ""}${date_picked.$D}/${
        date_picked.$M + 1 < 10 ? "0" : ""
      }${date_picked.$M + 1}/${date_picked.$y}`,
    }));
  };

  const handleChangeTipo = (e) => {
    setTipo(e.target.value);
    setFilters((prev) => ({ ...prev, tipo: e.target.value }));
  };

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <Grid container>
        <Grid
          xs={12}
          md={8}
          lg={4.5}
          item
          container
          className={s.boxModal}
          sx={{ bgcolor: "#EEEEEE" }}
        >
          <Grid item xs={10} className={s.exit}>
            <div className={s.titleModal}>
              <p>{t("filter")}</p>
              <span>{t("filterConfig")}</span>
            </div>
            <CloseIcon
              onClick={() => setOpen(false)}
              className={s.exitIcon}
              sx={{ color: "primary.dark" }}
            />
          </Grid>

          <Grid item container xs={10} sx={{ mt: 5 }}>
            <Grid sx={{ fontSize: "1.2rem", marginBottom: 3 }} item xs={12}>
              {t("date")}
            </Grid>
            <Grid item xs={12} sx={{ mb: 5 }}>
              <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale={i18n.language}
              >
                <DatePicker
                  label={t("date")}
                  inputFormat="DD/MM/YYYY"
                  value={fecha}
                  onChange={handleChangeDate}
                  renderInput={(params) => (
                    <TextField {...params} sx={{ width: "100%" }} />
                  )}
                  maxDate={new Date()}
                />
              </LocalizationProvider>
            </Grid>

            {/* Selector de tipo */}
            <Grid item xs={12} sx={{ mb: 3 }}>
              <FormControl fullWidth>
                <InputLabel>{t("type") || "Tipo"}</InputLabel>
                <Select
                  value={tipo}
                  label={t("type") || "Tipo"}
                  onChange={handleChangeTipo}
                >
                  {CIERRE_FILTER_OPTIONS.map((opt) => (
                    <MenuItem key={opt.value} value={opt.value}>
                      {t(opt.labelKey)}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Grid
            item
            xs={10}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              my: "20px",
            }}
          >
            <Button
              variant="contained"
              disabled={!agencieSelected}
              onClick={() => {
                setOpen(false);
                setSearching(true);
                setSearch(true);
              }}
            >
              {t("search")}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default ModalFiltros;
